import PaginatedList from '@theme/paginated-list';

/**
 * A custom element that renders a pagniated results list
 */
export default class ResultsList extends PaginatedList {
  /** @type {MutationObserver | undefined} */
  #resultsCountObserver;

  connectedCallback() {
    super.connectedCallback();

    this.#syncResultsCount();
    this.#observeResultsCount();
    this.setAttribute('initialized', '');
  }

  disconnectedCallback() {
    this.#resultsCountObserver?.disconnect();
  }

  #observeResultsCount() {
    const grid = this.querySelector('.product-grid');
    if (!(grid instanceof HTMLElement)) return;

    this.#resultsCountObserver?.disconnect();
    this.#resultsCountObserver = new MutationObserver(() => {
      this.#syncResultsCount();
    });

    this.#resultsCountObserver.observe(grid, { childList: true });
  }

  #syncResultsCount() {
    const countElements = this.querySelectorAll('[data-results-count]');
    if (countElements.length === 0) return;

    const loadedCount = this.querySelectorAll('.product-grid__item').length;

    countElements.forEach((element) => {
      if (!(element instanceof HTMLElement)) return;

      const totalCount = parseInt(element.dataset.resultsCountTotal ?? '0', 10);
      if (Number.isNaN(totalCount)) return;

      const hasResults = totalCount > 0 && loadedCount > 0;
      const startCount = hasResults ? 1 : 0;
      const endCount = hasResults ? Math.min(loadedCount, totalCount) : 0;

      const startElement = element.querySelector('[data-results-count-start]');
      const endElement = element.querySelector('[data-results-count-end]');
      if (startElement) startElement.textContent = startCount.toString();
      if (endElement) endElement.textContent = endCount.toString();
    });
  }
}

if (!customElements.get('results-list')) {
  customElements.define('results-list', ResultsList);
}
